export interface Protocol17025Cat_Interface {
  id:number,
  title:String,
  parent:number,
  subdate:String,
  username: String,
  child: Array<Protocol17025Cat_Interface>,
  childVisible:boolean
}

export function Empty_Protocol17025Cat_Interface():Protocol17025Cat_Interface{
  return{
    id:0,
    title:'',
    parent:0,
    subdate:'',
    username:'',
    child: [],
    childVisible:true
  }
}
